import React from "react";
import { Segmented } from "antd/lib";


interface IToggleEmployeeStatusProps {
    activeStatus: boolean;
    setActiveStatus: (value: boolean) => void;
}

function ToggleEmployeeStatus(props: IToggleEmployeeStatusProps) {

    function handleActiveUserView(value:string) {
       props.setActiveStatus(value==='active')
    }

    return (
        <div className="status-toggle-section">
            <span className="status-toggle-label">Employee Status</span>
            <Segmented
                className="status-toggle-buttons"
                options={[
                    {
                        label: 'Active',
                        value: 'active'
                    },
                    {
                        label: 'InActive',
                        value: 'inactive'
                    }
                ]}
                value={props.activeStatus ? 'active' : 'inactive'}
                onChange={(value) => handleActiveUserView(value)}
            />
            {/*<div className="status-toggle-buttons">*/}
            {/*    <button*/}
            {/*        type="button"*/}
            {/*        className={`status-btn ${props.activeStatus ? 'active' : ''}`}*/}
            {/*        onClick={() => props.setActiveStatus(true)}*/}
            {/*    >*/}
            {/*        Active*/}
            {/*    </button>*/}
            {/*    <button*/}
            {/*        type="button"*/}
            {/*        className={`status-btn ${!props.activeStatus ? 'active' : ''}`}*/}
            {/*        onClick={() => props.setActiveStatus(false)}*/}
            {/*    >*/}
            {/*        Inactive*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    )
}

export default ToggleEmployeeStatus;
